import { CART } from "../../actions/home/cart_action";

export const initState = {
  is_done: false,
  loading: false,
  errors: [],
  courses: [],
  certifications: [],
};

const cartReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case CART.ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
      };
    case CART.REQUEST:
      return {
        ...state,
        loading: true,
        is_done: false,
        errors: [],
        courses: [],
        certifications: [],
      };

    case CART.SHOW_ELEMENT_TO_CART:
      return {
        ...state,
        loading: false,
        is_done: false,
        errors: [],
        certifications: payload.certifications,
        courses: payload.courses,
      };

    case CART.ADD_ELEMENT_TO_CART:
    case CART.REMOVE_ELEMENT_TO_CART:
      return {
        ...state,
        loading: false,
        errors: [],
        is_done:true
      };
           
    default:
      return state;
  }
};

export default cartReducer;
